import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Typography, Box } from "@mui/material";
import { Edit } from "@mui/icons-material";
import {
  getOperationalStatusNameFromId,
  getOperationalStatusStyleName,
} from "../../../common/utils";
import NoDataLabel from "../../../components/common/NoDataLabel";
import ExecutionStatusField from "../../../components/common/ExecutionStatusField";

const OperationalStatusField = ({ operationalStatus }) => (
  <p
    className={`rounded p-2 ${getOperationalStatusStyleName(
      operationalStatus
    )}`}
  >
    {getOperationalStatusNameFromId(operationalStatus)}
  </p>
);

const EventTypeField = ({ eventType }) => (
  <p
    className="rounded p-2 default_operational_status"
    style={{
      background: eventType.BackgroundColor,
      color: eventType.ForegroundColor,
    }}
  >
    {eventType.Name}
  </p>
);

const generateField = (fieldType, fieldValue, editFunction) => {
  if (fieldValue !== null && fieldValue !== undefined && fieldValue !== "") {
    switch (fieldType) {
      case "operationalStatus":
        return <OperationalStatusField operationalStatus={fieldValue} />;
      case "eventType":
        return <EventTypeField eventType={fieldValue} />;
      case "currentStatus":
        return <ExecutionStatusField executionStatus={fieldValue} />;
      case "modificationDate":
      case "creationDate":
        return (
          <Typography>
            {new Date(fieldValue).toLocaleString(undefined, {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </Typography>
        );
      case "assignedTo":
        return fieldValue?.SurName ? (
          <Typography>
            {`${fieldValue?.SurName} ${fieldValue?.LastName}`}
          </Typography>
        ) : (
          fieldValue
        );
      case "vehicleAssigned":
        return (
          <Typography>
            {`(${fieldValue.VehicleType.Name}) ${fieldValue.Identification}`}
          </Typography>
        );
      case "bold":
        return (
          <Typography>
            <b>{fieldValue}</b>
          </Typography>
        );
      case "component":
        return fieldValue;
      default:
        if (editFunction) {
          return (
            <Box
              style={{
                display: "flex",
                gap: "5px",
              }}
            >
              <button
                onClick={() => {
                  editFunction();
                }}
              >
                <Edit
                  style={{
                    width: "20px",
                    height: "20px",
                    color: "#10366E",
                  }}
                />
              </button>
              <Typography>{fieldValue}</Typography>
            </Box>
          );
        }
        return <Typography>{fieldValue}</Typography>;
    }
  }

  return <NoDataLabel />;
};

export default function EventInfo({ rows, customWidthPercentage }) {
  return (
    <TableContainer
      sx={{ maxWidth: customWidthPercentage ?? "50%" }}
      component={Paper}
    >
      <Table sx={{ maxWidth: "100%" }} aria-label="simple table">
        <TableBody>
          {rows.map(
            (row) =>
              row && (
                <TableRow
                  key={row.fieldName}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    sx={{ padding: "5px !important;" }}
                  >
                    <b className="app_text_color">{`${row.fieldName}:`}</b>
                  </TableCell>
                  <TableCell align="left" sx={{ padding: "5px !important;" }}>
                    {generateField(
                      row.fieldType,
                      row.fieldValue,
                      row.editFunction
                    )}
                  </TableCell>
                </TableRow>
              )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
